import React from 'react';
import PropTypes from 'prop-types';
import {Grid, Row, Col} from '@/grid';
import Container from '@/container';
import {SectionPadding, SectionPaddingTopAd} from '@/section';
import {H1Neutral50} from '@/typography';
import {withBgLegalPages} from '@/hocs/withColors';

const SectionTitle = withBgLegalPages(SectionPadding);

const propTypes = {
  title: PropTypes.string.isRequired
};

const LegalHero = ({title}) => (
    <SectionPaddingTopAd>
      <SectionTitle className="print-bg">
        <Container>
          <Grid fluid>
            <Row>
              <Col xs={12}>
                <H1Neutral50 className="print-color">{title}</H1Neutral50>
              </Col>
            </Row>
          </Grid>
        </Container>
      </SectionTitle>
    </SectionPaddingTopAd>
  );

LegalHero.propTypes = propTypes;

export default LegalHero;
